<button *ngIf="row.id" type="button" class="btn btn-transparent" ngbTooltip="Preevisualizar documento" container="body"
    (click)="onPreviewFile()">
    <i class="ft-eye text-secondary"></i>
</button>

<ng-template #modalContent let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h4 class="modal-title">
            {{ row.name | uppercase }}
        </h4>
        <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <iframe *ngIf="safeUrl" [src]="safeUrl" width="100%" height="100%" frameborder="0"></iframe>
    </div>
</ng-template>